import React, {useEffect, useState} from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Home from "../../pages";
import Markets from "../../pages/Markets";
import AllNFTs from "../../pages/AllNFTs";
import ThreeDAnimation from "../../pages/ThreeDAnimation";
import Bedrooms from "../../pages/Bedrooms";
import Mancaves from "../../pages/Mancaves";
import Work from "../../pages/Work";
import About from "../../pages/About";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import People from "../../pages/People";
import PicturesPeople from "../../pages/PicturesPeople";
import PicturesMancavesAndBedrooms from "../../pages/PicturesMancavesAndBedrooms";
import VideosPeople from "../../pages/VideosPeople";
import VideosMancavesAndBedrooms from "../../pages/VideosMancavesAndBedrooms";
import RoadMap from "../../pages/Roadmap";

const CategoryContext = React.createContext();
const LoginContext = React.createContext();
const ProductContext = React.createContext();

function Navigation() {
  const [data, setData] = useState(null);
  const [localData, setLocalData] = useState(null);
  const [newError, setNewError] = useState(null)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  const getDataFromLocalJson = async () => {

    try {
      const response = await axios.get('/LocalData.json')
      setLocalData(response.data.items)
      setNewError(null);
    } catch (err) {
      setNewError(err.message);
      setLocalData(null);
    } finally {
      setLoading(false);


    }
  }

  const getData = async () => {
    try {
      const response = await axios.get("https://api.rarible.org/v0.1/items/byCreator?creator=ETHEREUM%3A0xdcAe3443075d8f4be70125d5076c3ba351f50863&size=102");
      setData(response.data.items)

      setError(null);
    } catch (err) {
      setError(err.message);
      setData(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getDataFromLocalJson();

    getData();
  }, []);


  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    !isOpen && setIsOpen(true)
  };

  return (

    <Router>
      <Sidebar isOpen={isOpen} close={() => setIsOpen(false)} toggle={toggle}/>
      <Navbar toggle={toggle}/>
      <Routes>
        <Route path="/" exact element={<Home loading={loading} data={data} localData={localData} error={error}/>}/>
        <Route path="/allnfts" element={<AllNFTs loading={loading} data={data} localData={localData} error={error}/>}/>
        <Route path="/3D-Animations"
               element={<ThreeDAnimation loading={loading} localData={localData} data={data} error={error}/>}/>
        <Route path="/People" element={<People loading={loading} data={data} localData={localData} error={error}/>}/>

        <Route path="/Mancaves"
               element={<Mancaves loading={loading} data={data} localData={localData} error={error}/>}/>
        <Route path="/Bedrooms"
               element={<Bedrooms loading={loading} data={data} localData={localData} error={error}/>}/>
        <Route path="/markets/:itemId" element={<Markets/>}/>
        <Route path="/markets/pictures/people"
               element={<PicturesPeople loading={loading} data={data} error={error} localData={localData}/>}/>
        <Route path="/markets/pictures/mancaves-and-bedrooms"
               element={<PicturesMancavesAndBedrooms loading={loading} data={data} error={error}
                                                     localData={localData}/>}/>
        <Route path="/markets/videos/people"
               element={<VideosPeople loading={loading} data={data} error={error} localData={localData}/>}/>
        <Route path="/markets/videos/mancaves-and-bedrooms"
               element={<VideosMancavesAndBedrooms loading={loading} data={data} error={error}
                                                   localData={localData}/>}/>
        <Route path="/work" element={<Work/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/roadmap" element={<RoadMap/>}/>
      </Routes>
    </Router>


  );
}


export {
  CategoryContext,
  LoginContext,
  ProductContext
};
export default Navigation;